<template>
  <div class="aggre" :class="{'isiOSX':isiOSX}">
    <van-nav-bar class="aggre-title" :fixed="true" :title="aggrement.title" />
    <img
      v-if="isPrev"
      @click="goBack()"
      class="aggre-reback"
      src="../../assets/myInvest/reback.png"
    />
    <img v-if="!isPrev" @click="prev" class="aggre-reback" src="../../assets/myInvest/reback.png" />
    <div class="aggre-content" v-html="aggrement.content"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      aggrement: "",
      isiOSX: false,
      isPrev: false
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    } else {
      this.$api.setToken();
      //			localStorage.removeItem('_token');
    }
    if (this.$route.query.from == 0) {
      this.isPrev = false;
    } else {
      this.isPrev = true;
    }
  },
  methods: {
    getAggrement() {
      var ID = this.$route.query.id;
      var number = this.$route.query.number;
      if (ID && ID != 11 && ID != 10 && ID != 20 && ID != 115) {
        this.$api.get("cms/member/agreement/detail", { id: ID }).then(res => {
          //内容管理-协议管理
          this.aggrement = res;
        });
      } else if (number || ID == 11 || ID == 10 || ID == 20 || ID == 115) {
        //用户注册协议
        var par = "";
        if (ID == 11) {
          par = "jl_yilian_bank";
        } else if (ID == 10) {
          par = "xbsh_ysxy";
        } else if (ID == 20) {
          par = "xbsj_privacy";
        } else if (ID == 115) {
          par = "xbgyl_yszc";
        } else if(number == 1) {
          par = "xbsh_register";
        }else {
          par = number;
        }
        this.$api.get("cms/index/agreement/detail?number=" + par).then(res => {
          //内容管理-协议管理
          this.aggrement = res;
        });
      }
    },
    goBack() {
      this.params("", "", "goBack");
    },
    prev() {
      this.$router.go(-1);
    }
  },
  mounted() {
    this.getAggrement();
  }
};
</script>

<style lang="less">
body {
  min-height: 100%;
  height: auto;
  .aggre {
    background: #f2f2f2;
    height: 100%;
    &-title {
      height: 44px;
      line-height: 44px;
      padding-top: 24px;
      box-shadow: 0 1px 0 #eee;
      .van-nav-bar__title {
        color: #333;
        font-size: 17px;
        font-weight: 700;
      }
    }
    &-reback {
      width: 15px;
      padding: 12px 15px;
      position: fixed;
      top: 27px;
      left: 0;
      z-index: 1;
    }
    &-content {
      background: #fff;
      padding: 16px;
      padding-top: 78px;
      box-sizing: border-box;
      height: 100%;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      img {
        width: 100% !important;
        display: block;
        height: auto !important;
      }
    }
  }
  .isiOSX {
    .aggre {
      &-title {
        padding-top: 44px;
      }
      &-reback {
        top: 45px;
      }
      &-content {
        padding-top: 98px;
      }
    }
  }
}
</style>
